/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreateGlobalRole200Response } from '../models';
// @ts-ignore
import type { CreateLocalRole200Response } from '../models';
// @ts-ignore
import type { GlobalRoleCreateDTO } from '../models';
// @ts-ignore
import type { GlobalRoleUpdateDTO } from '../models';
// @ts-ignore
import type { ListGlobalRoles200Response } from '../models';
// @ts-ignore
import type { ListLocalRoles200Response } from '../models';
// @ts-ignore
import type { LocalRoleCreateDTO } from '../models';
// @ts-ignore
import type { LocalRoleUpdateDTO } from '../models';
/**
 * NexusAccessRoleApi - axios parameter creator
 */
export const NexusAccessRoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new global role
         * @summary Create a global role
         * @param {GlobalRoleCreateDTO} globalRoleCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGlobalRole: async (globalRoleCreateDTO: GlobalRoleCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalRoleCreateDTO' is not null or undefined
            assertParamExists('createGlobalRole', 'globalRoleCreateDTO', globalRoleCreateDTO)
            const localVarPath = `/api/nora/nexus/access/role/global`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalRoleCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new local role
         * @summary Create a local role
         * @param {LocalRoleCreateDTO} localRoleCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocalRole: async (localRoleCreateDTO: LocalRoleCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'localRoleCreateDTO' is not null or undefined
            assertParamExists('createLocalRole', 'localRoleCreateDTO', localRoleCreateDTO)
            const localVarPath = `/api/nora/nexus/access/role/local`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(localRoleCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a specific global role from a global role id
         * @summary Deletes a global role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalRole: async (roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteGlobalRole', 'roleId', roleId)
            const localVarPath = `/api/nora/nexus/access/role/global/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a specific local role from a local role id
         * @summary Deletes a local role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocalRole: async (roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteLocalRole', 'roleId', roleId)
            const localVarPath = `/api/nora/nexus/access/role/local/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific global role from a global role id
         * @summary Get a global role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalRole: async (roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('getGlobalRole', 'roleId', roleId)
            const localVarPath = `/api/nora/nexus/access/role/global/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a specific local role from a local role id
         * @summary Get a local role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalRole: async (roleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('getLocalRole', 'roleId', roleId)
            const localVarPath = `/api/nora/nexus/access/role/local/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all global roles
         * @summary Lists all global roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGlobalRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/access/role/global`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all local roles
         * @summary List local roles
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocalRoles: async (type?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/access/role/local`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific global role from a global role id
         * @summary Update a global role
         * @param {string} roleId 
         * @param {GlobalRoleUpdateDTO} globalRoleUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalRole: async (roleId: string, globalRoleUpdateDTO: GlobalRoleUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateGlobalRole', 'roleId', roleId)
            // verify required parameter 'globalRoleUpdateDTO' is not null or undefined
            assertParamExists('updateGlobalRole', 'globalRoleUpdateDTO', globalRoleUpdateDTO)
            const localVarPath = `/api/nora/nexus/access/role/global/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(globalRoleUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific local role from a local role id
         * @summary Update a local role
         * @param {string} roleId 
         * @param {LocalRoleUpdateDTO} localRoleUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocalRole: async (roleId: string, localRoleUpdateDTO: LocalRoleUpdateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateLocalRole', 'roleId', roleId)
            // verify required parameter 'localRoleUpdateDTO' is not null or undefined
            assertParamExists('updateLocalRole', 'localRoleUpdateDTO', localRoleUpdateDTO)
            const localVarPath = `/api/nora/nexus/access/role/local/{roleId}`
                .replace('{roleId}', encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(localRoleUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NexusAccessRoleApi - functional programming interface
 */
export const NexusAccessRoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NexusAccessRoleApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new global role
         * @summary Create a global role
         * @param {GlobalRoleCreateDTO} globalRoleCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGlobalRole(globalRoleCreateDTO: GlobalRoleCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateGlobalRole200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGlobalRole(globalRoleCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.createGlobalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new local role
         * @summary Create a local role
         * @param {LocalRoleCreateDTO} localRoleCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocalRole(localRoleCreateDTO: LocalRoleCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLocalRole200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocalRole(localRoleCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.createLocalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a specific global role from a global role id
         * @summary Deletes a global role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGlobalRole(roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGlobalRole(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.deleteGlobalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a specific local role from a local role id
         * @summary Deletes a local role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocalRole(roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocalRole(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.deleteLocalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific global role from a global role id
         * @summary Get a global role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGlobalRole(roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateGlobalRole200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGlobalRole(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.getGlobalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a specific local role from a local role id
         * @summary Get a local role
         * @param {string} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocalRole(roleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateLocalRole200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocalRole(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.getLocalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all global roles
         * @summary Lists all global roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGlobalRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListGlobalRoles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGlobalRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.listGlobalRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all local roles
         * @summary List local roles
         * @param {string} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLocalRoles(type?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLocalRoles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLocalRoles(type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.listLocalRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a specific global role from a global role id
         * @summary Update a global role
         * @param {string} roleId 
         * @param {GlobalRoleUpdateDTO} globalRoleUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGlobalRole(roleId: string, globalRoleUpdateDTO: GlobalRoleUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGlobalRole(roleId, globalRoleUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.updateGlobalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a specific local role from a local role id
         * @summary Update a local role
         * @param {string} roleId 
         * @param {LocalRoleUpdateDTO} localRoleUpdateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocalRole(roleId: string, localRoleUpdateDTO: LocalRoleUpdateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocalRole(roleId, localRoleUpdateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusAccessRoleApi.updateLocalRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NexusAccessRoleApi - factory interface
 */
export const NexusAccessRoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NexusAccessRoleApiFp(configuration)
    return {
        /**
         * Create a new global role
         * @summary Create a global role
         * @param {NexusAccessRoleApiCreateGlobalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGlobalRole(requestParameters: NexusAccessRoleApiCreateGlobalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateGlobalRole200Response> {
            return localVarFp.createGlobalRole(requestParameters.globalRoleCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new local role
         * @summary Create a local role
         * @param {NexusAccessRoleApiCreateLocalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocalRole(requestParameters: NexusAccessRoleApiCreateLocalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLocalRole200Response> {
            return localVarFp.createLocalRole(requestParameters.localRoleCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a specific global role from a global role id
         * @summary Deletes a global role
         * @param {NexusAccessRoleApiDeleteGlobalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGlobalRole(requestParameters: NexusAccessRoleApiDeleteGlobalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteGlobalRole(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a specific local role from a local role id
         * @summary Deletes a local role
         * @param {NexusAccessRoleApiDeleteLocalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocalRole(requestParameters: NexusAccessRoleApiDeleteLocalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteLocalRole(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific global role from a global role id
         * @summary Get a global role
         * @param {NexusAccessRoleApiGetGlobalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGlobalRole(requestParameters: NexusAccessRoleApiGetGlobalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateGlobalRole200Response> {
            return localVarFp.getGlobalRole(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a specific local role from a local role id
         * @summary Get a local role
         * @param {NexusAccessRoleApiGetLocalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocalRole(requestParameters: NexusAccessRoleApiGetLocalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateLocalRole200Response> {
            return localVarFp.getLocalRole(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all global roles
         * @summary Lists all global roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGlobalRoles(options?: RawAxiosRequestConfig): AxiosPromise<ListGlobalRoles200Response> {
            return localVarFp.listGlobalRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all local roles
         * @summary List local roles
         * @param {NexusAccessRoleApiListLocalRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLocalRoles(requestParameters: NexusAccessRoleApiListLocalRolesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListLocalRoles200Response> {
            return localVarFp.listLocalRoles(requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific global role from a global role id
         * @summary Update a global role
         * @param {NexusAccessRoleApiUpdateGlobalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGlobalRole(requestParameters: NexusAccessRoleApiUpdateGlobalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.updateGlobalRole(requestParameters.roleId, requestParameters.globalRoleUpdateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific local role from a local role id
         * @summary Update a local role
         * @param {NexusAccessRoleApiUpdateLocalRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocalRole(requestParameters: NexusAccessRoleApiUpdateLocalRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.updateLocalRole(requestParameters.roleId, requestParameters.localRoleUpdateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createGlobalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiCreateGlobalRoleRequest {
    readonly globalRoleCreateDTO: GlobalRoleCreateDTO
}

/**
 * Request parameters for createLocalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiCreateLocalRoleRequest {
    readonly localRoleCreateDTO: LocalRoleCreateDTO
}

/**
 * Request parameters for deleteGlobalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiDeleteGlobalRoleRequest {
    readonly roleId: string
}

/**
 * Request parameters for deleteLocalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiDeleteLocalRoleRequest {
    readonly roleId: string
}

/**
 * Request parameters for getGlobalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiGetGlobalRoleRequest {
    readonly roleId: string
}

/**
 * Request parameters for getLocalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiGetLocalRoleRequest {
    readonly roleId: string
}

/**
 * Request parameters for listLocalRoles operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiListLocalRolesRequest {
    readonly type?: string
}

/**
 * Request parameters for updateGlobalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiUpdateGlobalRoleRequest {
    readonly roleId: string

    readonly globalRoleUpdateDTO: GlobalRoleUpdateDTO
}

/**
 * Request parameters for updateLocalRole operation in NexusAccessRoleApi.
 */
export interface NexusAccessRoleApiUpdateLocalRoleRequest {
    readonly roleId: string

    readonly localRoleUpdateDTO: LocalRoleUpdateDTO
}

/**
 * NexusAccessRoleApi - object-oriented interface
 */
export class NexusAccessRoleApi extends BaseAPI {
    /**
     * Create a new global role
     * @summary Create a global role
     * @param {NexusAccessRoleApiCreateGlobalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createGlobalRole(requestParameters: NexusAccessRoleApiCreateGlobalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).createGlobalRole(requestParameters.globalRoleCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new local role
     * @summary Create a local role
     * @param {NexusAccessRoleApiCreateLocalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createLocalRole(requestParameters: NexusAccessRoleApiCreateLocalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).createLocalRole(requestParameters.localRoleCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a specific global role from a global role id
     * @summary Deletes a global role
     * @param {NexusAccessRoleApiDeleteGlobalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteGlobalRole(requestParameters: NexusAccessRoleApiDeleteGlobalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).deleteGlobalRole(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a specific local role from a local role id
     * @summary Deletes a local role
     * @param {NexusAccessRoleApiDeleteLocalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteLocalRole(requestParameters: NexusAccessRoleApiDeleteLocalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).deleteLocalRole(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific global role from a global role id
     * @summary Get a global role
     * @param {NexusAccessRoleApiGetGlobalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getGlobalRole(requestParameters: NexusAccessRoleApiGetGlobalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).getGlobalRole(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a specific local role from a local role id
     * @summary Get a local role
     * @param {NexusAccessRoleApiGetLocalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLocalRole(requestParameters: NexusAccessRoleApiGetLocalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).getLocalRole(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all global roles
     * @summary Lists all global roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listGlobalRoles(options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).listGlobalRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all local roles
     * @summary List local roles
     * @param {NexusAccessRoleApiListLocalRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listLocalRoles(requestParameters: NexusAccessRoleApiListLocalRolesRequest = {}, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).listLocalRoles(requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific global role from a global role id
     * @summary Update a global role
     * @param {NexusAccessRoleApiUpdateGlobalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGlobalRole(requestParameters: NexusAccessRoleApiUpdateGlobalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).updateGlobalRole(requestParameters.roleId, requestParameters.globalRoleUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific local role from a local role id
     * @summary Update a local role
     * @param {NexusAccessRoleApiUpdateLocalRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLocalRole(requestParameters: NexusAccessRoleApiUpdateLocalRoleRequest, options?: RawAxiosRequestConfig) {
        return NexusAccessRoleApiFp(this.configuration).updateLocalRole(requestParameters.roleId, requestParameters.localRoleUpdateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

